import { ArelTooltip } from "@arelia-components/ui-atoms/Tooltip";
import { MerchSource } from "@arelia-types/earnings";
import EditNoteIcon from '@mui/icons-material/EditNote';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import CropSquareIcon from '@mui/icons-material/CropSquare';

interface Props {
  merchSource: MerchSource;
}

export function MerchTypeRenderer({ merchSource }: Props) {
  switch (merchSource) {
    case MerchSource.manual: return withTooltip(<EditNoteIcon />, "Manual Entry");
    case MerchSource.performance: return withTooltip(<MusicNoteIcon />, "Performance");
    case MerchSource.shopify: return withTooltip(<ShoppingBagOutlinedIcon />, "Shopify");
    case MerchSource.square: return withTooltip(<CropSquareIcon />, 'Square');
    default: return <></>;
  }
}

function withTooltip(elem: JSX.Element, title: string) {
  return (<ArelTooltip title={title}>{elem}</ArelTooltip>)
}